// Generated types for Succession
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ExpressionReadAPI, ExpressionWriteAPI } from './expression';
import { ExpressionReadAPISchemaObject, ExpressionWriteAPISchemaObject } from './expression';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SuccessionReadAPI extends Omit<ExpressionReadAPI, 'expression'> {
  /** Guard condition — boolean expression gating whether the target may follow the source, e.g. 'temp.value > 65' or 'system_mode == "ESTOP"'. Empty = unguarded (plain sequence). On a DECISION action's outgoing successions, guards select exactly one branch. References bind via Mentions like Constraint expressions. */
  expression?: string;
  /** Marks the DECISION catch-all branch — taken when no guarded sibling selects (SysML v2 `else`). Only valid when source_action.kind == DECISION. */
  is_else?: boolean;
  /** Evaluation order among a DECISION's outgoing branches — lower is tested FIRST (if / elif / else). The first guard that holds selects its branch, so guards need NOT be mutually exclusive: write the cascade in the order you mean it ('temp > 100' before 'temp > 60') instead of restating each earlier condition's complement. `is_else` is always evaluated last whatever its order_index. Meaningless (and rejected) when the source Action is not a DECISION. */
  order_index?: number;
}

export interface SuccessionWriteAPI extends Omit<ExpressionWriteAPI, 'expression'> {
  /** Guard condition — boolean expression gating whether the target may follow the source, e.g. 'temp.value > 65' or 'system_mode == "ESTOP"'. Empty = unguarded (plain sequence). On a DECISION action's outgoing successions, guards select exactly one branch. References bind via Mentions like Constraint expressions. */
  expression?: string;
  mentions?: string[];
  /** Marks the DECISION catch-all branch — taken when no guarded sibling selects (SysML v2 `else`). Only valid when source_action.kind == DECISION. */
  is_else?: boolean;
  /** Evaluation order among a DECISION's outgoing branches — lower is tested FIRST (if / elif / else). The first guard that holds selects its branch, so guards need NOT be mutually exclusive: write the cascade in the order you mean it ('temp > 100' before 'temp > 60') instead of restating each earlier condition's complement. `is_else` is always evaluated last whatever its order_index. Meaningless (and rejected) when the source Action is not a DECISION. */
  order_index?: number;
  /** Predecessor Action — must COMPLETE before the target may start. */
  source_action?: string;
  /** Successor Action — may not START until the source completes. */
  target_action?: string;
  /** Optional composite Action scoping this Succession. */
  parent_action?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SuccessionReadAPISchema: z.ZodType<SuccessionReadAPI> = ExpressionReadAPISchemaObject.omit({ 'expression': true }).extend({
  expression: z.string().optional(),
  is_else: z.boolean().optional(),
  order_index: z.number().optional(),
}).passthrough();

export const SuccessionWriteAPISchema: z.ZodType<SuccessionWriteAPI> = ExpressionWriteAPISchemaObject.omit({ 'expression': true }).extend({
  expression: z.string().optional(),
  mentions: z.array(z.string()).optional(),
  is_else: z.boolean().optional(),
  order_index: z.number().optional(),
  source_action: z.string().optional(),
  target_action: z.string().optional(),
  parent_action: z.string().optional(),
}).passthrough();
